import isString from 'lodash/isString'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

const formatTelephoneNumber = (telephone, _countryCode = null) => {
    let countryCode

    if (!telephone || !isString(telephone) || telephone.length < 10) {
        throw new Error('Invalid telephone number')
    }

    if (!_countryCode) {
        countryCode = 'GB'
    } else {
        countryCode = _countryCode.substring(0, 2).toUpperCase();
    }

    return parsePhoneNumberFromString(telephone, countryCode)
}

export const isTelephoneNumberValid = (telephone, countryCode = null) => {
    try {
        const formattedTelephoneNumber = formatTelephoneNumber(telephone, countryCode)

        return formattedTelephoneNumber.isValid()
    } catch (error) {
        return false
    }
}

export const telephoneNumberInternationalFormat = (telephone, countryCode) => {
    try {
        const formattedTelephoneNumber = formatTelephoneNumber(telephone, countryCode)

        return formattedTelephoneNumber.format('INTERNATIONAL')
    } catch (error) {
        return telephone
    }
}

export const isValidTelephone = (telephone) => isTelephoneNumberValid(telephone)
